module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-report-maintenance-settlement/master-report-maintenance-settlement.component.scss
// module id = ./src/app/master/master-report-maintenance-settlement/master-report-maintenance-settlement.component.scss
// module chunks = main